import script from "./StaffForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffForm.vue?vue&type=script&setup=true&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=569cdc98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-569cdc98"]])

export default __exports__